import {BreadCrumbItem} from './item';
import {BreadCrumbList} from './list';
import {BreadCrumbRoot} from './root';

export const breadCrumb = {
  root: BreadCrumbRoot,
  list: BreadCrumbList,
  item: BreadCrumbItem,
};
